import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import styles from './CardReaderCircle.module.scss'

const CardReaderCircle = ({ icon, className, ...props }) => {
  const classNames = cn(styles.cardReaderCircle, className)

  return (
    <div className={classNames} {...props}>
      <div className={styles.outerCircle}>
        <div className={styles.innerCircle}>
          {icon}
        </div>
      </div>
    </div>
  )
}

CardReaderCircle.defaultProps = {
  icon: null,
}

CardReaderCircle.propTypes = {
  icon: PropTypes.node,
}

export default CardReaderCircle
